import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18",
      cy: "18",
      r: "17",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.1484 24.2578C9.92578 24.4805 9.92578 24.8516 10.1484 25.0742L11.1133 26.0391C11.3359 26.2617 11.707 26.2617 11.9297 26.0391L15.6406 22.3281L16.791 23.5527C17.3477 24.1465 18.3125 23.7383 18.3125 22.9219V18.7656C18.3125 18.2832 17.9043 17.875 17.4219 17.875H13.2656C12.4492 17.875 12.041 18.8398 12.6348 19.3965L13.8594 20.5469L10.1484 24.2578ZM26.4395 11.5293C26.6621 11.3066 26.6621 10.9355 26.4395 10.7129L25.4746 9.74805C25.252 9.52539 24.8809 9.52539 24.6582 9.74805L20.9844 13.4219L19.7969 12.2344C19.2402 11.6406 18.3125 12.0488 18.3125 12.8281V16.9844C18.3125 17.5039 18.6836 17.875 19.166 17.875H23.3223C24.1387 17.875 24.5469 16.9473 23.9531 16.3906L22.7656 15.2031L26.4395 11.5293Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }